@if (variant() === 'horizontal') {
  <nav
    class="flex items-center gap-1 overflow-x-auto no-scrollbar py-0.5"
    aria-label="Navigation des sections"
  >
    @for (sec of sections(); track sec.id) {
      <button
        type="button"
        (click)="scrollToSection(sec.id)"
        class="group px-3 py-1.5 rounded-xl text-xs font-semibold shrink-0 flex items-center gap-1.5 cursor-pointer transition-all duration-150"
        [class.bg-indigo-9]="activeSection() === sec.id"
        [class.text-white]="activeSection() === sec.id"
        [class.shadow-xs]="activeSection() === sec.id"
        [class.text-gray-11]="activeSection() !== sec.id"
        [class.hover:text-gray-12]="activeSection() !== sec.id"
        [class.hover:bg-gray-3]="activeSection() !== sec.id"
      >
        <mat-icon
          class="!w-3.5 !h-3.5 !text-[14px] flex items-center justify-center leading-none select-none shrink-0"
          [class.text-white!]="activeSection() === sec.id"
          [class.text-gray-10!]="activeSection() !== sec.id"
          [class.group-hover:text-gray-12!]="activeSection() !== sec.id"
        >
          {{ sec.icon }}
        </mat-icon>
        <span>{{ sec.label }}</span>
        @if (sec.badge !== null && sec.badge !== undefined) {
          <span
            class="ml-1 px-1.5 py-0.2 rounded-full text-[10px] font-bold"
            [class.bg-white/20]="activeSection() === sec.id"
            [class.text-white]="activeSection() === sec.id"
            [class.bg-gray-4]="activeSection() !== sec.id"
            [class.text-gray-11]="activeSection() !== sec.id"
          >
            {{ sec.badge }}
          </span>
        }
      </button>
    }
  </nav>
} @else {
  <!-- Vertical Timeline Mode -->
  <nav class="relative flex flex-col py-1" aria-label="Sommaire chronologique des sections">
    <!-- Continuous Vertical Rail -->
    <div class="absolute left-[19px] top-3.5 bottom-3.5 w-0.5 bg-gray-5/70 rounded-full"></div>

    <div class="flex flex-col gap-1 relative">
      @for (sec of sections(); track sec.id) {
        <button
          type="button"
          (click)="scrollToSection(sec.id)"
          class="group flex items-center gap-3 px-2.5 py-2 rounded-xl text-left transition-all duration-200 cursor-pointer relative z-10 border"
          [class.bg-indigo-a3]="activeSection() === sec.id"
          [class.border-indigo-a5]="activeSection() === sec.id"
          [class.border-transparent]="activeSection() !== sec.id"
          [class.hover:bg-gray-3]="activeSection() !== sec.id"
        >
          <!-- Timeline Node Icon -->
          <div
            class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-200"
            [class.bg-indigo-9]="activeSection() === sec.id"
            [class.ring-4]="activeSection() === sec.id"
            [class.ring-indigo-a4]="activeSection() === sec.id"
            [class.shadow-xs]="activeSection() === sec.id"
            [class.bg-white]="activeSection() !== sec.id"
            [class.dark:bg-gray-2]="activeSection() !== sec.id"
            [class.border]="activeSection() !== sec.id"
            [class.border-gray-6]="activeSection() !== sec.id"
            [class.group-hover:border-indigo-7]="activeSection() !== sec.id"
            [class.group-hover:bg-indigo-a2]="activeSection() !== sec.id"
          >
            <mat-icon
              class="!w-4 !h-4 !text-[15px] flex items-center justify-center leading-none select-none shrink-0"
              [class.text-white!]="activeSection() === sec.id"
              [class.text-gray-11!]="activeSection() !== sec.id"
              [class.group-hover:text-indigo-9!]="activeSection() !== sec.id"
            >
              {{ sec.icon }}
            </mat-icon>
          </div>

          <!-- Label & Badge -->
          <div class="flex-1 min-w-0 flex items-center justify-between gap-2">
            <span
              class="text-xs truncate transition-colors duration-150"
              [class.text-indigo-11]="activeSection() === sec.id"
              [class.font-bold]="activeSection() === sec.id"
              [class.text-gray-11]="activeSection() !== sec.id"
              [class.font-medium]="activeSection() !== sec.id"
              [class.group-hover:text-gray-12]="activeSection() !== sec.id"
            >
              {{ sec.label }}
            </span>

            @if (sec.badge !== null && sec.badge !== undefined) {
              <span
                class="px-1.5 py-0.5 rounded-full text-[10px] font-bold shrink-0"
                [class.bg-indigo-a4]="activeSection() === sec.id"
                [class.text-indigo-11]="activeSection() === sec.id"
                [class.bg-gray-4]="activeSection() !== sec.id"
                [class.text-gray-11]="activeSection() !== sec.id"
              >
                {{ sec.badge }}
              </span>
            }
          </div>
        </button>
      }
    </div>
  </nav>
}
